import { RootState } from "@/redux/store";

export const dynamicPricingStatesSelector = (state: RootState) => state.trip.tripCost.dynamicPricing.pricingStates;
export const dynamicPricingStateSelector = (slug: string) => (state: RootState) =>
  state.trip.tripCost.dynamicPricing.pricingStates.find((l) => l.state === slug);
export const dynamicPricingPageStateSelector = (state: RootState) => state.trip.tripCost.dynamicPricing.pageState;

export const pricingProfilesSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pricingProfiles;
export const pricingProfilesPageSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pricingProfilesPage;

export const pricingProfileSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pricingProfile;
export const nationwideFixedPricingSelector = (state: RootState) => state.trip.tripCost.fixedPricing.nationwidePricing;
export const fixedPricingStatesSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pricingStates;
export const fixedPricingStateSelector = (slug: string) => (state: RootState) =>
  state.trip.tripCost.fixedPricing.pricingStates.find((s) => s.state === slug);
export const fixedPricingLocationsSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pricingLocations;
export const fixedPricingLocationSelector = (id: string) => (state: RootState) =>
  state.trip.tripCost.fixedPricing.pricingLocations.find((l) => l.id === id);
export const fixedPricingPageStateSelector = (state: RootState) => state.trip.tripCost.fixedPricing.pageState;

export const timeAndDaySelector = (state: RootState) => state.trip.timeAndDay.items;
export const timeAndDayPageSelector = (state: RootState) => state.trip.timeAndDay.page;
export const cancellationFeesSelector = (state: RootState) => state.trip.cancellationFees.standardPricing;
export const asapPricingSelector = (state: RootState) => state.trip.cancellationFees.asapPricing;
export const standardPricingSelector = (state: RootState) => state.trip.cancellationFees.standardPricing;
export const hourlyHireSelector = (state: RootState) => state.trip.hourlyHire.pricing;
export const hourlyHireMinimumSelector = (state: RootState) => state.trip.hourlyHire.minimumBookingPeriodMinutes;
export const dailyHireSelector = (state: RootState) => state.trip.dailyHire.pricing;
export const dailyHireMinimumSelector = (state: RootState) => state.trip.dailyHire.minimumBookingPeriodMinutes;
export const unscheduledStopsSelector = (state: RootState) => state.trip.unscheduledStops;
